// Client-safe email-capture helpers shared by the swipe-deck popups.
// (Keep this free of server-only imports — it runs in the browser.)

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value.trim());
}

export type SavePromptInput = {
  likedCount: number;
  hasEmail: boolean;
  dismissed: boolean;
};

/**
 * Whether to show the "enter your email to save your favorites" prompt when a
 * visitor leaves the swipe deck. Only prompt when there's something to save,
 * we don't already have their email, and they haven't dismissed it before.
 */
export function shouldPromptSaveFavorites({ likedCount, hasEmail, dismissed }: SavePromptInput): boolean {
  return likedCount > 0 && !hasEmail && !dismissed;
}
